import { BuildOutlined, History } from '@mui/icons-material'
import { Box, useTheme } from '@mui/material'
import { Context, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ILocality } from 'src/generated-types'
import { IMainComponent } from 'src/generated-types/main-component'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import { MainComponentPerformHistoryDialog } from '../../maintenance/MainComponentPerformHistoryDialog'
import { MainComponentHistoriesTable } from '../MainComponentHistoriesTable'
import EquipmentSectionLayout from './EquipmentSectionLayout'

interface Props {
  context: Context<any> | null | undefined
  customerId: EntityId
  localityId: EntityId | undefined
  mainComponentId: any
  mainComponent: IMainComponent | undefined
  locality: ILocality | undefined
  pop?: () => void
  permission?: number
}

const HistoryAndMaintenanceSection = (props: Props) => {
  const { mainComponent, customerId, localityId, mainComponentId, permission } = props
  const { t } = useTranslation(['main-component'])
  const theme = useTheme()
  const [historyRowCount, setHistoryRowCount] = useState(0)

  return (
    <Box>
      <Box mb={2}>
        <EquipmentSectionLayout
          title={t('history', { ns: 'activity-logs' })}
          icon={<History sx={{ fontSize: '18px', color: getThemeColor(theme, MUIThemeColors.primaryMain) }} />}
          context={props.context}
          contentContainerStyle={{
            marginTop: '-40px',
            height: historyRowCount >= 8 ? '350px' : 'auto',
          }}
          content={
            <MainComponentHistoriesTable
              customerId={customerId}
              localityId={localityId as EntityId}
              equipmentLocalityId={mainComponent?.selectedLocalityId as EntityId | undefined}
              mainComponentId={mainComponentId as EntityId}
              mooringId={mainComponent?.position?.mooringId as EntityId}
              enablePagination={false}
              pop={props.pop}
              height="300px"
              autoHeight={true}
              maxVisibleRowCount={8}
              minimalEmptyStatus={true}
              onDataLengthChange={setHistoryRowCount}
              context={props.context}
              permission={permission}
            />
          }
        />
      </Box>
      <Box>
        <EquipmentSectionLayout
          title={t('maintenance-history', { ns: 'maintenance' })}
          icon={<BuildOutlined sx={{ fontSize: '18px', color: getThemeColor(theme, MUIThemeColors.primaryMain) }} />}
          context={props.context}
          content={
            <MainComponentPerformHistoryDialog
              customerId={customerId}
              mainComponentId={mainComponentId as EntityId}
              tableRowHeight={36}
              pop={props.pop || (() => {})}
              height="350px"
              autoHeight={true}
              maxVisibleRowCount={8}
              minimalEmptyStatus={true}
            />
          }
        />
      </Box>
    </Box>
  )
}

export default HistoryAndMaintenanceSection
